import React, { Component } from "react";
import { connect } from "react-redux";
import TunersAndInput from "../../../Create_portfolio_by_Advisor/common/tunersAndinput";

class TunersAndInputHolder extends Component {
  state = {
    max_value: 0,
    min_return: 0,
    upper_bound: 0,
    max_beta: 0,
    max_beta_subheading: "",
    renderTuners: false,
  };

  componentWillMount() {
    const { slected_obj, optimization_params, activePortfolioID } = this.props;
    this.setTunersData({ slected_obj, optimization_params, activePortfolioID });
  }
  componentDidMount() {
    const { slected_obj, optimization_params, activePortfolioID } = this.props;
    this.setTunersData({ slected_obj, optimization_params, activePortfolioID });
  }
  // componentWillReceiveProps(nextProps) {
  //   const { slected_obj, optimization_params, activePortfolioID } = nextProps;
  //   if (
  //     JSON.stringify(this.props.slected_obj) !==
  //     JSON.stringify(nextProps.slected_obj)
  //   ) {
  //     this.setTunersData({
  //       slected_obj,
  //       optimization_params,
  //       activePortfolioID,
  //     });
  //   }
  // }
  // Setting Tuners value
  setTunersData = ({ slected_obj, optimization_params, activePortfolioID }) => {
    console.log("=========set Tuners data ============");

    console.log({ slected_obj, optimization_params, activePortfolioID });
    console.log("=====================");
    if (slected_obj && Object.keys(slected_obj).length > 0) {
      let max_value =
        activePortfolioID &&
        optimization_params[activePortfolioID] &&
        optimization_params[activePortfolioID]["max_vol"]
          ? optimization_params[activePortfolioID]["max_vol"]
          : 0;

      let min_return =
        activePortfolioID &&
        optimization_params[activePortfolioID] &&
        optimization_params[activePortfolioID]["min_return"]
          ? optimization_params[activePortfolioID]["min_return"]
          : 0;

      let upper_bound =
        activePortfolioID &&
        optimization_params[activePortfolioID] &&
        optimization_params[activePortfolioID]["upper_bounds"]
          ? optimization_params[activePortfolioID]["upper_bounds"]
          : 0;

      let max_beta_value =
        activePortfolioID &&
        optimization_params[activePortfolioID] &&
        optimization_params[activePortfolioID]["max_beta"]
          ? optimization_params[activePortfolioID]["max_beta"]
          : 0;
      max_beta_value = +(max_beta_value * 1).toFixed(2);
      let max_beta = Array.from({ length: 301 }, (v, k) => k / 100).indexOf(
        max_beta_value
      );

      let _max_beta_value = slected_obj["max_beta"]
        ? slected_obj["max_beta"]
        : 0;
      _max_beta_value = +(_max_beta_value * 1).toFixed(2);

      let value = `${
        +_max_beta_value - 0.1 < 0 ? 0 : (_max_beta_value - 0.1).toFixed(2)
      } - ${
        +_max_beta_value + 0.1 > 3 ? 3 : (_max_beta_value + 0.1).toFixed(2)
      }`;

      this.setState({
        max_value: max_value < 0 ? 0 : max_value,
        min_return: min_return < 0 ? 0 : min_return,
        upper_bound: upper_bound < 0 ? 0 : upper_bound,
        max_beta: max_beta < 0 ? 0 : max_beta,
        max_beta_subheading: value,
        renderTuners: true,
      });
    }
  };
  //====================
  // Tuners handler
  volatilitySliderHandler = (value) => {
    const ID = this.props.activePortfolioID;
    value = value.substring(0, value.length - 1) * 1;

    if (value >= 0) {
      this.props.changeUIParams(
        ["optimization_params", "max_vol"],
        +value,
        +ID
      );
    } else return;
  };

  returnSliderHandler = (value) => {
    const ID = this.props.activePortfolioID;
    value = value.substring(0, value.length - 1) * 1;
    if (value >= 0) {
      this.props.changeUIParams(
        ["optimization_params", "min_return"],
        +value,
        +ID
      );
    } else return;
  };

  maxLimitSliderHandler = (value) => {
    const ID = this.props.activePortfolioID;
    value = value.substring(0, value.length - 1) * 1;
    if (value >= 0) {
      this.props.changeUIParams(
        ["optimization_params", "upper_bounds"],
        +value,
        +ID
      );
    } else return;
  };

  maxBetaSliderHandler = (value) => {
    const ID = this.props.activePortfolioID;
    value = value.substring(0, value.length) * 1;
    if (!value) return;
    this.props.changeUIParams(["optimization_params", "max_beta"], +value, +ID);
  };

  tunersHandler = ({ value, type }) => {
    const ID = this.props.activePortfolioID;
    console.log({ value, type });
    value =
      type === "max_beta"
        ? value.substring(0, value.length) * 1
        : value.substring(0, value.length - 1) * 1;
    if (value >= 0) {
      this.props.changeUIParams(["optimization_params", type], +value, +ID);
    } else return;
  };
  //==============
  portfolioNameHandler = (value) => {
    this.props.setPortfolioName(value);
  };
  render() {
    const { activePortfolioID, optimization_params, scenarioName } = this.props;
    const {
      max_value,
      min_return,
      upper_bound,
      max_beta,
      renderTuners,
    } = this.state;

    return (
      <div className="tunersAndInputHolder">
        {renderTuners &&
        activePortfolioID &&
        Object.keys(optimization_params).length > 0 ? (
          <TunersAndInput
            str1="cr1"
            str2="cr2"
            str3="cr3"
            str4="cr4"
            volatality={max_value}
            returns={min_return}
            max_limit={upper_bound}
            max_beta={max_beta}
            tunersHandler={this.tunersHandler}
            scenario_id={activePortfolioID}
            volatility_type="max_vol"
            return_type="min_return"
            max_limit_type="upper_bounds"
            max_beta_type="max_beta"
            scenario_name={scenarioName}
            portfolioNameHandler={this.portfolioNameHandler}
            btnDisabled={true}
            btnHandler={(e) => console.log(e)}
            creatingPortfolioSpinner={false}
            failedCreatingPortfolio={false}
            noScenarioIDreturned={false}
            displayTuners={true}
            displayCreateButton={false}
            absoluteTunersValue={true}
          />
        ) : null}
      </div>
    );
  }
}

export default connect(
  ({
    create: {
      steps: {
        backendParams: { optimization_params },
        risk: { activePortfolioID, scenarioName },
        universeLite: { securityUniverseActive },
        tuners_absolute_selection: {
          selected_type,
          absolute_max_vol,
          absolute_min_return,
          absolute_max_beta,
        },
      },
    },
  }) => ({
    activePortfolioID,
    optimization_params,
    securityUniverseActive,
    scenarioName,
    selected_type,
    slected_obj: optimization_params[activePortfolioID],
    absolute_max_vol,
    absolute_min_return,
    absolute_max_beta,
  }),
  (dispatch) => ({
    changeUIParams: (ui_ixs, ui_value, id) =>
      dispatch({ type: "CHANGE_UI_PARAMS", payload: { ui_ixs, ui_value, id } }),
    setPortfolioName: (value) =>
      dispatch({ type: "SET_PORTFOLIO_NAME", payload: value }),
  })
)(TunersAndInputHolder);



// WEBPACK FOOTER //
// ./src/components/pages/Create/Theme_base/Tuners_and_input/TunersAndInputHolder.jsx